import { ControlledFormInput } from '@components/formInputs/ControlledFormInput';
import { isValidEmailOrWhiteSpaceRule } from '@components/formInputs/rules';
import { LayoutVariant } from '@components/formInputs/sharedTypes';
import { formatPhone } from '@utils/formatPhone';
import { useFormContext } from 'react-hook-form';
import { type AdminRestaurant } from '../../team/apiHelpers';
import { SettingsOutletHeader } from '../../shared/SettingsOutletHeader';
import { type GeneralSettingsForm } from '../utils/generalSettingsFormTypes';
import { FieldBlock } from '../shared/FieldBlock';
import fieldBlockStyles from '../shared/FieldBlock.scss';
import layoutStyles from './DetailsSection.scss';

export interface DetailsSectionProps {
  restaurant: AdminRestaurant;
  sectionTitleId: string;
}

export const DetailsSection = ({
  restaurant,
  sectionTitleId,
}: DetailsSectionProps) => {
  const { control } = useFormContext<GeneralSettingsForm>();

  return (
    <section className={layoutStyles.section} aria-labelledby={sectionTitleId}>
      <SettingsOutletHeader
        variant="section"
        titleId={sectionTitleId}
        title="Details"
      />
      <div className={layoutStyles.formFields}>
        <FieldBlock label="Name">
          <p className={layoutStyles.readOnlyValue}>{restaurant.name}</p>
        </FieldBlock>
        <FieldBlock label="Website">
          <p className={layoutStyles.readOnlyValue}>{restaurant.website}</p>
        </FieldBlock>
        <FieldBlock label="Phone Number">
          <p className={layoutStyles.readOnlyValue}>
            {formatPhone(restaurant.phone)}
          </p>
        </FieldBlock>
        <ControlledFormInput
          control={control}
          label="Support Email"
          labelClassName={fieldBlockStyles.fieldLabel}
          name="supportEmail"
          rules={{
            validate: {
              supportEmail: isValidEmailOrWhiteSpaceRule,
            },
          }}
          type="email"
          variant={LayoutVariant.Vertical}
          className={layoutStyles.constrainedField}
        />
      </div>
    </section>
  );
};
